import { useEffect } from 'react';
import ENV from '../env.json';
import { toFullName } from '../services/user';

export type HelpscoutUserData = {
  user: {
    email: string;
    preferredName: string;
    lastName: string;
  };
  org: { id: string; name: string };
};

export const useHelpscoutIdentify = (currentUser: HelpscoutUserData | null) => {
  useEffect(() => {
    const HS = (window as any).Beacon;
    if (!HS) {
      console.log('Beacon not found');
      return;
    }

    // logout
    if (!currentUser) {
      HS('logout');
    }

    if (currentUser) {
      // show Beacon only for logged in users
      HS('init', ENV.helpscout.appId);
      HS('identify', {
        name: toFullName(currentUser.user),
        email: currentUser.user.email,
        company: currentUser.org.name
      });
    }
  }, [currentUser]);
};
